const ExpertAvatar = ({ name, score, type }: { name: string; score: number; type: 'dany' | 'yannick' | 'francois' }) => {
  const displayName = type === 'yannick' ? 'Dany' : name;
  const prefix = type === 'dany' || type === 'yannick' ? 'CA/CE' : 'VP Techno';
  
  const avatarConfig = {
    dany: {
      ringColor: 'ring-orange-400',
      url: '/DB.png',
    },
    yannick: {
      ringColor: 'ring-orange-400',
      url: '/DB.png',
    },
    francois: {
      ringColor: 'ring-blue-400',
      url: '/FP.png',
    },
  };
  
  const config = avatarConfig[type];

  return (
    <div className="flex flex-col items-center gap-0.5">
      {/* Avatar */}
      <div className={`w-10 h-10 rounded-full shadow-lg ring-2 ${config.ringColor} overflow-hidden relative bg-transparent backdrop-blur-sm`}>
        <img 
          src={config.url} 
          alt={`${prefix} ${displayName}`}
          className="w-full h-full object-cover"
        />
        {/* Effet tatou/gravure */}
        <div className="absolute inset-0 rounded-full bg-gradient-to-b from-white/10 via-transparent to-black/20"></div>
      </div>
      
      {/* Nom avec préfixe */}
      <span className="text-[10px] font-semibold text-white drop-shadow-md text-center">
        {displayName}
      </span>
      
      {/* Étoiles */}
      <div className="flex gap-0.5">
        {[...Array(5)].map((_, index) => (
          <svg
            key={index}
            className={`w-2 h-2 ${
              index < score 
                ? 'text-yellow-400 drop-shadow-[0_0_2px_rgba(250,204,21,0.8)]' 
                : 'text-gray-400 opacity-40'
            }`}
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          </svg>
        ))}
      </div>
    </div>
  );
};

export default ExpertAvatar;
